import { useMemo } from 'react';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import {
  IObjektVy,
  BusinessCollectionCompType,
} from '../../../../../Types/ObjektVy';
import BusinessDataForm from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import useNodeQuery from '../../../../../Components/QueryComponents/NodeQuery/useNodeQuery';
import query from './Queries/AttestantQuery.gql';
import {
  AttestantQuery,
  AttestantQuery_node_TEDLRAttestant,
  AttestantQueryVariables,
} from './Queries/_QueryTypes/AttestantQuery';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import AttributGrupp from '../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import AttributeHeader from '../../../../../Components/Attributes/AttributeHeader/AttributeHeader';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import {
  AssociationList,
  IAssociationListConfig,
} from '../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import { Reserver } from './Components/Reserver/Reserver';
import {
  definedSelectedId,
  selectedId,
} from '../../../../../Components/MasterDetail/MasterDetailUtils';

const attestantModel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRAttestant;

const Attestant: BusinessCollectionCompType = props => {
  const id = props.id ? props.id : '';
  const {
    nodeData,
    loading: nodeLoading,
    refetch,
  } = useNodeQuery<
    AttestantQuery,
    AttestantQuery_node_TEDLRAttestant,
    AttestantQueryVariables
  >(query, selectedId(props.id), {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !props.id,
    variables: {
      id: definedSelectedId(id),
      toDate: new Date().toLocaleDateString('sv-SE'),
    },
  });

  const attestrattConfig = useMemo<IAssociationListConfig>(() => {
    return {
      defaultVisningstyp: 'kort',
      inCard: true,
      customDefaultColumns: [
        {
          attributeDef: 'Attestomrade.BENAMNING',
          caption: 'Attestområde',
          header: true,
        },
        { attributeDef: 'AKTIV', header: false },
        { attributeDef: 'TITEL', header: false },
        { attributeDef: 'Kontobehorighet', header: false },
        {
          attributeDef: 'MOTTAGN_ATTEST',
          header: false,
        },
        {
          attributeDef: 'BESLUT_ATTEST',
          header: false,
        },
        { attributeDef: 'KONTROLL_BELOPP', header: false },
        { attributeDef: 'KONTROLL_BELOPP', header: false },
        { attributeDef: 'HarFakturareferenser', header: false },
      ],
    };
  }, []);

  const reservVyer = useMemo(() => {
    return [Reserver];
  }, []);

  return (
    <BusinessDataForm<AttestantQuery_node_TEDLRAttestant>
      isNew={props.isNew}
      data={nodeData}
      fullScreen={props.config?.fullPage ?? false}
      refetchData={refetch}
      dataLoading={nodeLoading}
      model={attestantModel}
    >
      <ObjektVy nodeLoading={nodeLoading}>
        <ObjektVySida
          sidNr={1}
          caption="Attestant"
          collectionName={attestantModel.CollectionName}
          columns={2}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn fullPage>
              <AttributGrupp>
                <AttributeHeader attributeGroups={['SIGNATUR', 'BENAMNING']} />
              </AttributGrupp>
            </ObjektVyKolumn>
            <ObjektVyKolumn>
              <ObjektVyKort caption="Attesträtter">
                {id && (
                  <AssociationList
                    associationName="Attestratt"
                    collectionName={attestantModel.CollectionName}
                    ownId={selectedId(id)}
                    config={attestrattConfig}
                  />
                )}
              </ObjektVyKort>
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
        <ObjektVySida
          sidNr={2}
          caption="Frånvaro"
          collectionName={attestantModel.CollectionName}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn>
              <AttributGrupp>
                <AttributeHeader attributeGroups={['BENAMNING']} />
              </AttributGrupp>
            </ObjektVyKolumn>
            <ObjektVyKolumn>
              <ObjektVyKort
                readOnly
                vyer={reservVyer}
                caption="Reserver"
                bmod={attestantModel}
                id={id}
              />
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};

const attestantObjektVy = collectionCompToObjektVy(Attestant, 'Attestant');

export const AttestantVyer: IObjektVy[] = [attestantObjektVy];
